/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    textLabelWithAsterisk: {
        marginBottom: theme.spacing(1.5),
        marginTop: theme.spacing(-0.5),
        fontFamily: 'GilmerMedium',
        fontSize: '13px',
        color: '#1D2028',
        lineHeight: '24px'
    },
    copyTextInput : {
        maxWidth: theme.spacing(87.5),
    },
    cancelBtn: {
        marginRight: theme.spacing(1),
        height: theme.spacing(5),
        fontSize: 13,
        fontFamily: 'GilmerMedium'
    },
    keyInfo: {
        backgroundColor: '#F0F1FB',
        borderLeftStyle: 'solid',
        borderLeftColor: '#5567D5',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    keyInfoWarning: {
        backgroundColor: '#ffcc8c2b',
        borderLeftStyle: 'solid',
        borderLeftColor: '#FF9D52',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    infoHeader: {
        fontFamily: 'GilmerMedium',
        fontSize: '13px',
        lineHeight: '24px',
        color: '#1D2028'
    },
    infoText: {
        fontFamily: 'Gilmer',
        lineHeight: '20px',
        color: theme.palette.secondary.dark,
        width: '90%'
    },
    infoIcon: {
        color: '#5567D5',
        fontSize: 'large'
    },
    warningIcon: {
        ...theme.custom.apiOverviewPage.tabs.tryout.warningIcon
    },
    
}));

export default useStyles;
